var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',{staticClass:"page-banner page-banner-sec"},[_c('h1',{staticClass:"section-title"},[_vm._v(_vm._s(_vm.$t('messages.header')))])]),_c('div',{staticClass:"wrapper"},[_c('SideBar'),_c('div',{staticClass:"col p-0",attrs:{"id":"content"}},[_c('router-view')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }